import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAppSelector } from "./store/hooks";

/**
 * Gate for the signed-in area.
 *
 * Being signed in means holding a session, not holding a valid one: an expired
 * access token is refreshed by the transport, and a refresh token the API
 * rejects clears the session, at which point this redirects. Trying to decide
 * validity here would mean parsing a token the client cannot verify.
 *
 * The attempted location is carried in state so a sign-in can return the person
 * to where they were going.
 */
const PrivateRoute = () => {
    const location = useLocation();
    const signedIn = useAppSelector((state) => Boolean(state.auth.accessToken));

    if (!signedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <Outlet />;
};

export default PrivateRoute;
